import loadingGif from 'asset/images/loading.gif'; 

const PrLoading = ({
    width = '50px',
    height = '50px'
}) => {
    return <img src={loadingGif} alt="Loading..." style={{ width, height }} />;
}
export default PrLoading;